import { render, staticRenderFns } from "./AlgerianPriceReaderFR.vue?vue&type=template&id=6a8f623c&scoped=true"
import script from "./AlgerianPriceReaderFR.vue?vue&type=script&lang=js"
export * from "./AlgerianPriceReaderFR.vue?vue&type=script&lang=js"
import style0 from "./AlgerianPriceReaderFR.vue?vue&type=style&index=0&id=6a8f623c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8f623c",
  null
  
)

export default component.exports